import { meetups } from "@/mocks/fanCommunity";
import { dotClasses } from "./tone";

const MEET_IMG =
  "https://readdy.ai/api/search-image?query=Beautiful%20fan%20meetup%20stage%20decorated%20with%20warm%20coral%20flowers%20and%20cream%20drapery%2C%20soft%20string%20lights%2C%20elegant%20seating%20rows%20in%20front%2C%20cozy%20intimate%20celebrity%20fan%20event%20atmosphere%2C%20editorial%20photography%20high%20detail&width=1000&height=1200&seq=meet-stage-2026&orientation=portrait";

export default function MeetupSection() {
  return (
    <section id="meetup" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center lg:gap-12">
          {/* image */}
          <div className="relative order-2 lg:order-1">
            <div className="aspect-[5/6] w-full overflow-hidden rounded-2xl">
              <img
                src={MEET_IMG}
                alt="吃瓜捷克粉丝见面会舞台布置"
                title="吃瓜捷克见面会舞台"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-3 rounded-xl bg-primary-500 px-5 py-4 text-background-50 md:-right-6">
              <p className="font-display text-2xl md:text-3xl">Say Hi</p>
              <p className="mt-1 text-xs md:text-sm text-background-100/90">面对面，双向奔赴</p>
            </div>
          </div>

          {/* schedule */}
          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-calendar-event-line" />
              见面会 · 场次安排
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
              下一场见面会，不见不散
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              各城市见面会时间持续更新。开票信息与参与要求请以官方售票平台为准，届时本站也会同步提醒。
            </p>

            <ul className="mt-8 divide-y divide-background-200">
              {meetups.map((m) => (
                <li key={m.city + m.date} className="flex items-center gap-4 py-4">
                  <span className={`flex h-3 w-3 shrink-0 rounded-full ${dotClasses[m.statusTone]}`} />
                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {m.city} · {m.venue}
                    </h3>
                    <p className="mt-0.5 text-xs md:text-sm text-foreground-500">计划日期：{m.date}</p>
                  </div>
                  <span
                    className={`shrink-0 rounded-full px-3 py-1 text-xs font-medium ${
                      m.statusTone === "primary"
                        ? "bg-primary-100 text-primary-800"
                        : m.statusTone === "accent"
                        ? "bg-accent-100 text-accent-800"
                        : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    {m.status}
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-6 flex items-start gap-2 rounded-lg border border-background-200 bg-background-50 p-4 text-xs md:text-sm text-foreground-600">
              <i className="ri-shield-check-line mt-0.5 text-accent-600" />
              <p>
                购票提示：见面会门票请通过官方售票平台与粉丝定向渠道获取，勿轻信非官方转售信息，谨防诈骗。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}